/**
 * usePreferencesSync Hook
 * 
 * Handles loading preferences from backend when user is authenticated.
 * This hook should be called once on app initialization.
 * 
 * Validates: Requirements 9.3, 9.5
 */

import { useEffect, useRef } from 'react';
import { useDAWStore } from '../store/daw-store';

export const usePreferencesSync = () => {
  const loadPreferencesFromBackend = useDAWStore((state) => state.loadPreferencesFromBackend);
  const hasLoaded = useRef(false);

  useEffect(() => {
    // Only load once on mount
    if (hasLoaded.current) return;
    hasLoaded.current = true;

    // Load preferences from backend if authenticated
    // This will override localStorage with backend preferences (Requirements 9.5)
    loadPreferencesFromBackend().catch(err => {
      console.error('Failed to load preferences from backend:', err);
    });
  }, [loadPreferencesFromBackend]);
};
